import { opcionesDelCombo, platillosDelCombo, buildSteps } from './combos';

// Una vez por visita (pestaña): recargar o volver desde WhatsApp no la repite.
const SEEN_KEY = 'announcement_seen';

const seenStamp = (a) => `${a.id}:${a.updated_at || ''}`;

export const wasAnnouncementSeen = (a) => {
  try {
    return sessionStorage.getItem(SEEN_KEY) === seenStamp(a);
  } catch {
    return false;
  }
};

export const markAnnouncementSeen = (a) => {
  try {
    sessionStorage.setItem(SEEN_KEY, seenStamp(a));
  } catch {
    // Sin storage (modo privado): se vuelve a mostrar, no pasa nada.
  }
};

/**
 * El combo al que lleva "Ordenar", acotado a los productos de la novedad: el
 * paso de cada categoría marcada solo ofrece esos (los 6 pasteles de Costco).
 * Solo se acota con lo que el combo ya admite; si ninguno cabe, el paso queda
 * como estaba. Un único producto en su paso se precarga.
 *
 * Devuelve { combo, initialSelections } o null si el combo no existe.
 */
export function comboDeNovedad(announcement, combos) {
  const base = combos.find((c) => Number(c.id) === Number(announcement?.cta_combo_id));
  if (!base) return null;

  const featured = announcement.featured_items || [];
  let combo = base;
  for (const cat of base.categories || []) {
    const deLaCat = featured.filter((it) => Number(it.category_id) === Number(cat));
    if (deLaCat.length === 0) continue;
    const caben = Number(cat) === 1
      ? platillosDelCombo(base, combos, deLaCat)
      : opcionesDelCombo(base, Number(cat), deLaCat);
    if (caben.length === 0) continue;
    const ids = caben.map((it) => Number(it.id));
    combo = Number(cat) === 1
      ? { ...combo, mainItems: ids }
      : { ...combo, allowedItems: { ...(combo.allowedItems || {}), [cat]: ids } };
  }

  const steps = buildSteps(combo.categories);
  const seeds = steps.map((s) => {
    const lista = Number(s.cat) === 1 ? combo.mainItems : (combo.allowedItems || {})[s.cat];
    const marcados = featured.filter((it) => Number(it.category_id) === Number(s.cat));
    return marcados.length > 0 && Array.isArray(lista) && lista.length === 1 ? { id: lista[0] } : null;
  });
  return { combo, initialSelections: seeds.some(Boolean) ? seeds : null };
}
